import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JobSectionsService } from './logic/job-section.service';
import { JobSectionsLogicService } from './logic/job-section/job-section-logic.service';
import { JobSectionsDaoService } from './dao/job-section-dao.service';
import { JobSectionsDbDaoService } from './dao/job-section-dao/job-section-db-dao.service';
import { JobSectionDbTableDefinition } from './dao/job-section-dao/job-section-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: JobSectionsService, useClass: JobSectionsLogicService },
    { provide: JobSectionsDaoService, useClass: JobSectionsDbDaoService },
    { provide: JobSectionDbTableDefinition },
  ]
})
export class JobSectionsModule {}
